import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const subPartnerParamsSchema = object({
  subPartnerId: stringToNumber()
})
